<template lang="pug">
transition(name="fade")
  .WalkthroughModal
    .inner
      iframe.iframe(:src="pages[sceneNumber].path")
      .closeButton(@click="handleCloseButtonClick")
        font-awesome-icon.icon(icon="times-circle")
      .footerMenu
        label.permanentCloseButton
          input(type="checkbox" @change="handlePermanentCloseButtonClick" :checked="isPermanentClose ? 'checked' : ''")
          | 次回以降表示しない

        .stepIndicator
          .stepIndicatorItem(
            v-for="page,i in pages"
            :class="{'stepIndicatorItem--current': i === sceneNumber}"
          )

        km-button.nextButton(
          v-if="sceneNumber < 6"
          @click="handleNextButtonClick"
        ) 次へ
        km-button.finishButton(
          v-if="sceneNumber === 6"
          @click="handleFinishButtonClick"
        ) はじめる
    .bg
</template>

<script>
export default {
  name: 'km-walkthrough-modal',
  components: {},
  props: {
    pages: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      sceneNumber: 0,
      isPermanentClose: false
    }
  },
  computed: {},
  methods: {
    handlePermanentCloseButtonClick(e) {
      if (e.target.checked) {
        this.$cookie.set('top_walkthrough_permanentclose', true)
      } else {
        this.$cookie.delete('top_walkthrough_permanentclose')
      }
    },
    handleNextButtonClick() {
      this.sceneNumber += 1
    },
    handleFinishButtonClick() {
      this.$emit('onClose')
    },
    handleCloseButtonClick() {
      this.$emit('onClose')
    }
  },
  mounted() {
    this.isPermanentClose = this.$cookie.get('top_walkthrough_permanentclose')
  }
}
</script>

<style lang="scss" scoped>
.WalkthroughModal {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.inner {
  position: relative;
  top: 0;
  width: 800px;
  height: 650px;
  padding: 0 0 65px;
  border: 5px solid #333;
  background: #fff;
  text-align: center;
  border-radius: 10px;
  z-index: 2;
}

.iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

.closeButton {
  position: absolute;
  top: -15px;
  right: -15px;
  display: inline-block;
  padding: 3px;
  background: #333;
  color: #fff;
  line-height: 1;
  font-size: 3rem;
  border-radius: 50%;
}

.footerMenu {
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 65px;
  background: #333;
}

.permanentCloseButton {
  position: absolute;
  left: 20px;
  padding: 0 10px;
  color: #fff;

  input {
    margin-right: 10px;
  }
}

.stepIndicator {
  display: flex;
}

.stepIndicatorItem {
  display: block;
  margin: 0 1px;
  width: 16px;
  height: 16px;
  border: 1px solid #333;
  background: #fff;
  border-radius: 9px;

  &--current {
    background: orange;
  }
}

.nextButton {
  position: absolute;
  right: 0;
  width: 120px;
}

.finishButton {
  position: absolute;
  right: 0;
  width: 120px;
}

.bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}
</style>
